import { FC } from 'react';

import StepProgressPips from './StepProgressPips';

type StepProgressTopBarProps = {
  totalSteps: number;
  currentStep: number;
};

/**
 * The progress chrome above every step funnel (GYTR + readiness). Leads with
 * the pips on a light surface, with a modest top margin.
 */
const StepProgressTopBar: FC<StepProgressTopBarProps> = ({
  totalSteps,
  currentStep
}) => (
  <div className="bg-neutral-100 px-6 pt-6 pb-2">
    <div className="mx-auto max-w-sm">
      <StepProgressPips totalSteps={totalSteps} currentStep={currentStep} />
    </div>
  </div>
);

export default StepProgressTopBar;
